import { useEffect, useState } from "react";
import { FormControl } from "@mui/material";
import { useDebounce, useTranslate } from "@/hooks";
import { IActionTransfer } from "@/types/ses/sesItemConfigTypes";
import { CustomTextField } from "@/components/MUI";
import { ISaveHandlerProps, ITransferProps } from "./Transfer.props";

const Transfer = ({ action, idx, channel, isDisabled, handleSaveActionInStore }: ITransferProps): JSX.Element => {
	const [inputDestination, setInputDestination] = useState<string>(action.destination); // место назначения

	const translate = useTranslate(); // hook для перевода текста
	const debouncedInputDestination = useDebounce(inputDestination, 1000); // задержка обработки назначения

	// следим за назначением
	useEffect(() => {
		if (debouncedInputDestination !== action.destination) {
			transferActionDataChangeHandler({ destination: debouncedInputDestination });
		}
	}, [debouncedInputDestination]);

	// обработчик изменения данных действия "Передача диалога" (transfer)
	const transferActionDataChangeHandler = ({ destination }: Partial<ISaveHandlerProps>): void => {
		const data: { channel: string; idx: number; action: Partial<IActionTransfer> } = { channel, idx, action: { destination: destination ?? inputDestination } };
		handleSaveActionInStore(data);
	};

	return (
		// назначение
		<FormControl fullWidth>
			<CustomTextField
				label={translate("input_destination")}
				variant="outlined"
				value={inputDestination}
				onChange={(e) => setInputDestination(e.target.value)}
				disabled={isDisabled}
				error={!inputDestination}
				title={inputDestination}
			/>
		</FormControl>
	);
};

export default Transfer;
